const removeFromDate = (millis) => {
    return (date: Date): Date => {
        return !date ? date : new Date(Math.floor(date.getTime() / millis) * millis);
    };
};

export const removeHours = removeFromDate(24 * 3600 * 1000);

export const removeMinutes = removeFromDate(3600 * 1000);
